// 手写线性图标集(24x24, stroke=currentColor),避免 emoji 拼贴的"AI 模板脸"。
// 覆盖全站所需的最小集合;新增图标请保持同一线宽/圆角风格。
import type { SVGProps } from "react";

const paths: Record<string, string> = {
  search: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35",
  folder: "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z",
  flask: "M9 3h6M10 3v6.5L4.8 18a1.7 1.7 0 0 0 1.5 2.5h11.4a1.7 1.7 0 0 0 1.5-2.5L14 9.5V3",
  wrench: "M14.7 6.3a4 4 0 0 0-5.6 5.1L3 17.5 6.5 21l6.1-6.1a4 4 0 0 0 5.1-5.6l-2.8 2.8-2.2-2.2 2.2-2.6z",
  upload: "M12 16V4M7 9l5-5 5 5M4 20h16",
  "chevron-right": "M9 18l6-6-6-6",
  "chevron-down": "M6 9l6 6 6-6",
  x: "M18 6 6 18M6 6l12 12",
  "external-link": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3",
  star: "M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5-4.7-4.6 6.5-.9z",
  trash: "M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0-.8 13a2 2 0 0 1-2 1.9H8.8a2 2 0 0 1-2-1.9L6 6h12z",
  download: "M12 3v13M6 11l6 6 6-6M5 21h14",
  copy: "M9 9h10v10H9zM5 15V5a1 1 0 0 1 1-1h10",
  "check-circle": "M22 11.1V12a10 10 0 1 1-6-9.2M22 4 12 14.01l-3-3",
  "alert-triangle": "M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4m0 4h.01",
  "file-text": "M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 3v5h5M9 13h6M9 17h6",
  clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2",
  "arrow-right": "M5 12h14M13 6l6 6-6 6",
  plus: "M12 5v14M5 12h14",
  share: "M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M16 6l-4-4-4 4M12 2v14",
  command: "M6 9a3 3 0 1 1 3 3H9a3 3 0 1 1-3 3v-9a3 3 0 1 1 3 3H6zm9 0a3 3 0 1 1 3 3h-3zm0 6a3 3 0 1 0 3 3v-3z",
  layout: "M3 4h18v6H3zM3 14h8v6H3zM13 14h8v6h-8z",
  book: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 19.5V6a2 2 0 0 1 2-2h14v15.5M4 19.5V22h16v-2.5",
  table: "M3 5h18v14H3zM3 10h18M9 5v14",
  image: "M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM21 15l-5.5-5.5a1 1 0 0 0-1.4 0L4 19",
  inbox: "M22 12h-6l-2 3h-4l-2-3H2M5.4 5.3 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.4-6.7A2 2 0 0 0 16.8 4H7.2a2 2 0 0 0-1.8 1.3z",
  stethoscope: "M6 3v6a4 4 0 0 0 8 0V3M10 15a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-1M4 3v6M20 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  bell: "M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0",
  user: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  translate: "M4 5h7M9 3v2c0 4-2 8-6 10M5 9c1.5 2 3.5 3.5 6 4M14 21l4-9 4 9M15.5 18h5",
  compass: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM16 8l-3 6-6 3 3-6z",
  layers: "M12 2 2 7l10 5 10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
  refresh: "M21 2v6h-6M3 22v-6h6M3.5 9a9 9 0 0 1 15-4l2.5 2.5M20.5 15a9 9 0 0 1-15 4L3 16.5",
  sliders: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6",
};

export function Icon({
  name,
  size = 18,
  strokeWidth = 2,
  ...rest
}: { name: keyof typeof paths | string; size?: number; strokeWidth?: number } & SVGProps<SVGSVGElement>) {
  const d = paths[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}
